import { l10nEnService } from '@uplift/services';
import * as Yup from 'yup';
import { AddressType, SexEnum } from '@uplift/types';
import { createDobFieldValidation, settingsAddressValidation } from '@uplift/ui-v2';

export type AboutYouFormType = {
  sex: SexEnum | null;
  pronouns?: string;
  dateOfBirth: string | null;
  address: AddressType;
};

export const aboutYouValidation = (l10n: typeof l10nEnService): Yup.ObjectSchema<AboutYouFormType> =>
  Yup.object({
    sex: Yup.mixed<SexEnum>().oneOf([ SexEnum.female, SexEnum.male ]).required(l10n.validations.sex),
    pronouns: Yup.string().notRequired().max(64, l10n.validations.lengthMatches(1, 64)),
    dateOfBirth: createDobFieldValidation(l10n, {
      adult: true,
      adultMsg: l10n.validations.dob.mustBe18ForBetterhelpPsychiatry,
    }),
    address: settingsAddressValidation(l10n),
  }) as Yup.ObjectSchema<AboutYouFormType>;
